import React from "react";
import image1 from "../../../assets/images/CompanyLogo/business.webp";
import arrow from "../../../assets/icons/arrowright1.svg";
import { Link } from "react-router-dom";

const ClaimBusiness = () => {
  const handleClaimNowClick = () => {
    window.scrollTo(0, 0);
  };
  return (
    <div
      style={{ marginTop: "65px" }}
      className="max-w-[1200px] mx-auto mt-12 sm:mt-[120px] text-center sm:text-left sm:flex sm:flex-row-reverse m-0 justify-start py-6"
    >
      <div className="flex items-center px-4 sm:px-0 sm:justify-center sm:items-start flex-col sm:w-[50%] m-0 mx-auto">
        <h1 className="text-f24 uppercase sm:normal-case sm:text-f24 md:text-[2rem] lg:text-[2rem] leading-[1.3] font-bold text-primary mt-4">
          Access Your Business
        </h1>
        <h6 className="text-f14 sm:text-[1rem] text-[#3C4848] mt-2 leading-[21px]">
          Find and access your business profile on TREVEX for free! Take full
          control of your business information and enhance it to showcase your
          business in the best possible light. No more involvement of
          third-parties!
        </h6>
        <div className="mt-6 sm:mt-8 ">
          <Link
            to="/search"
            onClick={handleClaimNowClick}
            className="flex text-left mb-4 font-bold text-f16 border border-[#1d1415] bg-[#0000] text-[#1d1415] px-[1rem] py-[0.75rem] text-center items-center justify-center rounded hover:bg-[#e6ecf0] transition duration-300"
          >
            Access Now
            {/* <img src={arrow} alt="Arrow" className="w-6 h-6 ml-4" /> */}
          </Link>
        </div>
      </div>
      <div className="flex sm:w-[40%] justify-center sm:justify-start sm:mr-10">
        <img
          src={image1}
          alt="YourImage"
          className="max-h-[357px] px-4 sm:pl-4 sm:pr-4 sm:max-h-[571px] md:pl-8 md:pr-8 flex-shrink-0 rounded-8"
        />
      </div>
    </div>
  );
};

export default ClaimBusiness;
